export function isoDateInTimeZone(date: Date, timeZone: string) {
  return new Intl.DateTimeFormat('sv-SE', { timeZone }).format(date)
}

export function dateRail(startIso: string, length = 7) {
  const [year, month, day] = startIso.split('-').map(Number)
  const start = new Date(Date.UTC(year!, month! - 1, day!, 12))
  return Array.from({ length }, (_, index) => {
    const date = new Date(start)
    date.setUTCDate(start.getUTCDate() + index)
    return new Intl.DateTimeFormat('sv-SE', { timeZone: 'UTC' }).format(date)
  })
}

export function shiftCivilDate(value: string, days: number) {
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(Date.UTC(year!, month! - 1, day! + days, 12))
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'UTC' }).format(date)
}

export function startOfCivilWeek(value: string, firstDay = 1) {
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(Date.UTC(year!, month! - 1, day!, 12))
  const distance = (date.getUTCDay() - firstDay + 7) % 7
  return shiftCivilDate(value, -distance)
}

export function shiftCivilMonth(value: string, months: number) {
  const [year, month, day] = value.split('-').map(Number)
  const target = new Date(Date.UTC(year!, month! - 1 + months, 1, 12))
  const lastDay = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0, 12)).getUTCDate()
  target.setUTCDate(Math.min(day!, lastDay))
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'UTC' }).format(target)
}

export function civilMonthGrid(value: string, firstDay = 1) {
  const monthStart = `${value.slice(0, 7)}-01`
  const from = startOfCivilWeek(monthStart, firstDay)
  return { from, to: shiftCivilDate(from, 41), dates: dateRail(from, 42) }
}

export function formatCivilDate(value: string, locale: string, options: Intl.DateTimeFormatOptions) {
  return new Intl.DateTimeFormat(locale, { ...options, timeZone: 'UTC' }).format(new Date(`${value}T12:00:00Z`))
}

export function timeLabel(value: string, locale: string, timeZone: string) {
  return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', timeZone }).format(new Date(value))
}

export function hourInTimeZone(value: string, timeZone: string) {
  const hour = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', hourCycle: 'h23', timeZone })
    .formatToParts(new Date(value))
    .find((part) => part.type === 'hour')?.value
  return Number(hour)
}

export function localDateTimeToIso(date: string, time: string, timeZone: string) {
  const [year, month, day] = date.split('-').map(Number)
  const [hour, minute] = time.split(':').map(Number)
  const target = Date.UTC(year!, month! - 1, day!, hour!, minute!)
  let candidate = target

  for (let attempt = 0; attempt < 3; attempt += 1) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date(candidate)).map((part) => [part.type, part.value]))
    const represented = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute))
    const correction = target - represented
    candidate += correction
    if (correction === 0) break
  }

  return new Date(candidate).toISOString()
}
